import * as React from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import { isBluecoinsOpenAtom } from '../../Bluecoins/BluecoinState';
import { isWaypointsOpenAtom } from '../../Waypoints/WaypointState';
import { filterStringAtom, isSearchBarOpenAtom } from '../../OnlineMapState';
import useAnalytics from '../../../../hooks/useAnalytics';

function SearchControl(): JSX.Element {
  const filterString = useRecoilValue<string>(filterStringAtom);
  const isWaypointsOpen = useRecoilValue(isWaypointsOpenAtom);
  const { formatMessage: f } = useIntl();
  const isBluecoinsOpen = useRecoilValue<boolean>(isBluecoinsOpenAtom);
  const setIsSearchBarOpen = useSetRecoilState<boolean>(isSearchBarOpenAtom);
  const { trackEvent } = useAnalytics();

  const handleShowSearchBarWindow = (_event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    trackEvent(['map', 'click', 'Vehicle search on map']);
    setIsSearchBarOpen(true);
  };

  return (
    <a
      onClick={isWaypointsOpen || isBluecoinsOpen ? undefined : handleShowSearchBarWindow}
      data-cy="controls-map-searchbar"
      title={f({ id: 'map.searchbar.placeholder' })}
      className={`${
        filterString.length > 0
          ? 'cmd-icons cmd-icon-search search bubble-on'
          : 'cmd-icons cmd-icon-search search'
      }`}
    >
      {/* &nbsp; */}
    </a>
  );
}

export default SearchControl;
